import { render, staticRenderFns } from "./subscribePublish.vue?vue&type=template&id=4b6b291b"
import script from "./subscribePublish.vue?vue&type=script&lang=js"
export * from "./subscribePublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports